import request from '@/utils/request'

// 提交直播申请
export function submitLiveApply(data) {
  return request({
    url: '/app-api/service/liveApply/submitLiveApply/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取用户直播间申请记录列表
export function getUserLiveApplyRecordList(query) {
  return request({
    url: '/app-api/service/liveApply/getUserLiveApplyRecordList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取直播申请记录详情
export function getLiveApplyInfo(query) {
  return request({
    url: '/app-api/service/liveApply/getLiveApplyInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 撤回直播申请(仅待审核可以撤回)
export function returnLiveApply(data) {
  return request({
    url: '/app-api/service/liveApply/returnLiveApply/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取直播申请可用时段列表
export function getLiveApplyTimeList(data) {
  return request({
    url: '/app-api/service/liveApply/getLiveApplyTimeList/v1_0_0',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/zhiboshenqing.js